import { useMediaQuery } from '@mui/material';

/**
 * `true` em telas pequenas (mobile).
 *
 * Atalho para o caso mais comum do app: dialogs que viram tela cheia, barras
 * fixas e gestos exclusivos de toque. Aceita outro breakpoint quando a tela
 * precisa de mais espaço (ex.: `useIsMobile('md')`).
 *
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} breakpoint Limite superior do mobile.
 */
export const useIsMobile = (breakpoint = 'sm') =>
  useMediaQuery((theme) => theme.breakpoints.down(breakpoint));

export default useIsMobile;
